// extracted by mini-css-extract-plugin
export default {"formy-actions":"_formy-actions_fMYH+6"};